import { assert as assertImpl } from "../generator/util/assert.js";
export type RefreshHandler = () => void;

declare global {
  const PRODUCTION: boolean;

  interface Window {
    refreshHandlers?: RefreshHandler[];
    refreshAfterContentDecode(): void;
  }
}

/**
 * Assert function that can be removed in production.
 * @param cond The condition to assert.
 * @param msg Optional assertion message.
 */
export function assert(cond: unknown, msg?: string): asserts cond {
  if (!PRODUCTION) {
    assertImpl(cond, msg);
  }
}

function urlCleanup() {
  let url = window.location;
  if (url.hostname == "md.ekstrandom.net") return; // bail if we're live
  if (url.hostname == "localhost") return; // all the nope

  let elts = document.querySelectorAll("a.office, iframe.office");
  for (let e of elts) {
    console.log("fixing up element", e);
    let attr = e.tagName == "A" ? "href" : "src";
    let linkSrc = e.getAttribute(attr);
    let link = new URL(linkSrc!);
    if (link.hostname.includes("officeapps")) {
      let slides = new URL(link.searchParams.get("src")!);
      slides.host = url.host;
      slides.protocol = url.protocol;
      link.searchParams.set("src", slides.toString());
    }
    e.setAttribute(attr, link.toString());
  }
}

function installUrlCleanup() {
  urlCleanup();
  window.refreshHandlers = [urlCleanup];
}

export function installDevHelpers() {
  window.refreshAfterContentDecode = function() {
    for (let f of this.refreshHandlers ?? []) {
      f();
    }
  };

  if (!PRODUCTION) {
    installUrlCleanup();
  }
}
